import { Box, Divider, Stack, Typography } from '@mui/material';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';

import lookingForCandidates from '@assets/looking-for-candidates.png';
import { IPositionWithCandidates } from '@types';
import { formatPositionTitle } from '@utils';

import { EmptyStateCard } from '../EmptyStateCard/EmptyStateCard';

interface INoCandidatesStateProps {
  positions: IPositionWithCandidates[];
}

export const NoCandidatesState: React.FC<INoCandidatesStateProps> = ({
  positions,
}) => (
  <Stack>
    <EmptyStateCard
      image={lookingForCandidates}
      title="We’re looking for candidates"
      description="Please expect email from us once we have matching profiles"
    />

    <Divider sx={{ borderColor: 'background.divider' }} />

    <Box px={2} py={2}>
      <Typography variant="body1" color="text.secondary">
        Open positions for your account
      </Typography>
    </Box>

    {positions.map((position) => (
      <Box
        key={position.id}
        display="flex"
        alignItems="flex-start"
        gap="7px"
        pl="13px"
        pr="6px"
        py={1}
      >
        <WorkOutlineIcon
          sx={{ fontSize: 20, color: 'action.active', flexShrink: 0 }}
        />
        <Typography fontSize={13} lineHeight="18px" letterSpacing="0.16px">
          {formatPositionTitle(position)}
        </Typography>
      </Box>
    ))}
  </Stack>
);
